import React, { useState } from 'react';
import { Button } from './button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './dropdown-menu';
import { Download, FileJson, FileSpreadsheet, Loader2 } from 'lucide-react';

/**
 * Shared Export Dropdown Component
 * Consistent export UI across all tabs
 * 
 * @param {Object} props
 * @param {Function} props.onExport - Called with format ('json' | 'csv') when user selects
 * @param {boolean} props.disabled - Disable the dropdown
 * @param {boolean} props.loading - Show loading spinner
 * @param {string} props.className - Additional classes for the trigger button
 * @param {Array} props.formats - Which formats to show, default ['json', 'csv']
 */
const ExportDropdown = ({ 
  onExport, 
  disabled = false, 
  loading = false,
  className = '',
  formats = ['json', 'csv']
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleExport = (format) => {
    setIsOpen(false);
    if (onExport) {
      onExport(format);
    }
  };

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="outline" 
          size="sm" 
          className={`border-gray-200 h-9 ${className}`}
          disabled={disabled || loading}
        >
          {loading ? (
            <Loader2 className="w-4 h-4 mr-2 animate-spin" />
          ) : (
            <Download className="w-4 h-4 mr-2" />
          )}
          Export
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[140px]">
        {formats.includes('json') && (
          <DropdownMenuItem 
            onClick={() => handleExport('json')} 
            className="cursor-pointer"
          >
            <FileJson className="w-4 h-4 mr-2" />
            JSON
          </DropdownMenuItem>
        )}
        {formats.includes('csv') && (
          <DropdownMenuItem 
            onClick={() => handleExport('csv')} 
            className="cursor-pointer"
          >
            <FileSpreadsheet className="w-4 h-4 mr-2" />
            CSV
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ExportDropdown;
